import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
export class ActorFilterGlobal extends ActorFilterRegistryCategory {
    label = 'Global';
    constructor(parent) {
        super(parent);
        super.init();
    }
    all = () => new ActorFilterRegistryItem({ label: 'Kein Filter', filter: () => true });
    none = () => new ActorFilterRegistryItem({ label: 'Kein Akteur', filter: () => false });
}
